export const CONTACT = {
  phone: "+36 70 586 2627",
  phoneHref: "+36705862627",
  email: "info@szuper-szaki.hu",
  hours: "Hétfő – Szombat: 07:00 – 19:00",
};

// Facebook Messenger: set `messenger` to your Page username (the part after m.me/ or facebook.com/).
// Example: if your page is facebook.com/szuperszaki -> messenger: "szuperszaki"
export const SOCIAL = {
  messenger: "61595566333984", // Facebook oldal ID -> m.me/61595566333984
  facebookUrl: "https://www.facebook.com/people/Szuper-szakihu/61595566333984/",
};

export const SERVICES = [
  {
    icon: "Droplets",
    title: "Vízvezeték-szerelés",
    desc: "Teljes körű víz­vezeték kiépítés, bővítés és felújítás precízen, garanciával.",
  },
  {
    icon: "Wrench",
    title: "Csap, szifon & WC-tartály",
    desc: "Csapok, szifonok és WC-tartályok gyors javítása vagy cseréje bármilyen típusnál.",
  },
  {
    icon: "ShieldAlert",
    title: "Csőtörés & szivárgás",
    desc: "Rejtett csőtörések bemérése, szivárgások megszüntetése minimális bontással.",
  },
  {
    icon: "Flame",
    title: "Fűtésrendszer szerelés",
    desc: "Fűtésrendszerek kiépítése, javítása és karbantartása a hosszú élettartamért.",
  },
  {
    icon: "Thermometer",
    title: "Radiátor csere",
    desc: "Radiátorok szakszerű cseréje, bekötése és légtelenítése, tisztán dolgozva.",
  },
  {
    icon: "Hammer",
    title: "Kis- és nagyobb munkák",
    desc: "A csöpögő csaptól a teljes gépészetig – egyéni vállalkozóként, közvetlenül.",
  },
];

export const WHY = [
  { icon: "Clock", title: "Pontos érkezés", desc: "Egyeztetett időpontban ott vagyok – a határidő nálam szent." },
  { icon: "Receipt", title: "Átlátható árak", desc: "Előre tisztázott díjak, rejtett költségek nélkül, írásban." },
  { icon: "Sparkles", title: "Tiszta munkaterület", desc: "A munka végén úgy hagyom a helyet, ahogy találtam – tisztán." },
  { icon: "ShieldCheck", title: "Vállalkozói garancia", desc: "Egyéni vállalkozóként a nevemmel és garanciával állok a munkáért." },
];

export const AREAS = {
  budapest: {
    label: "Budapest és vonzáskörzete",
    places: ["Budapest összes kerülete", "Budaörs", "Érd", "Dunakeszi", "Budakeszi", "Szentendre", "Gödöllő"],
  },
  keszthely: {
    label: "Keszthely és a Balaton nyugati medencéje",
    places: ["Keszthely", "Hévíz", "Gyenesdiás", "Vonyarcvashegy", "Cserszegtomaj", "Alsópáhok", "Zalakaros"],
  },
};

export const TESTIMONIALS = [
  {
    name: "Nagy Erika",
    place: "Budapest, XIII. kerület",
    text: "Csöpögő csapunkhoz hívtuk, de kiderült, hogy a szifon is rossz. Pontosan jött, mindent megmutatott, korrekt áron megoldotta. Csak ajánlani tudom!",
    job: "Csap- és szifoncsere",
  },
  {
    name: "Kovács Tamás",
    place: "Hévíz",
    text: "A fűtésünk télen mondta fel a szolgálatot. Fülöp másnap kijött, bemérte a hibát, és estére már meleg volt a ház. Megbízható, rendes ember.",
    job: "Fűtésrendszer javítás",
  },
  {
    name: "Szabó Judit",
    place: "Keszthely",
    text: "Radiátorcserét kértünk három szobába. Tisztán, precízen dolgozott, a végén mindent feltakarított. Végre egy szaki, akiben meg lehet bízni.",
    job: "Radiátorcsere",
  },
];

export const STATUS_OPTIONS = [
  { id: "új", label: "Új", color: "bg-blue-100 text-blue-800 border-blue-200", dot: "bg-blue-500" },
  { id: "felvettük a kapcsolatot", label: "Felvettük a kapcsolatot", color: "bg-amber-100 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  { id: "folyamatban", label: "Folyamatban", color: "bg-purple-100 text-purple-800 border-purple-200", dot: "bg-purple-500" },
  { id: "lezárva", label: "Lezárva", color: "bg-emerald-100 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  { id: "komolytalan", label: "Komolytalan", color: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
];
